import { render, staticRenderFns } from "./ViewReservedAccountDetails.html?vue&type=template&id=73adcef0&scoped=true&external"
import script from "./ViewReservedAccountDetails.vue?vue&type=script&lang=ts"
export * from "./ViewReservedAccountDetails.vue?vue&type=script&lang=ts"
import style0 from "./Account.scss?vue&type=style&index=0&id=73adcef0&prod&lang=scss&scoped=true&external"
import style1 from "./ViewReservedAccountDetails.vue?vue&type=style&index=1&id=73adcef0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73adcef0",
  null
  
)

export default component.exports